export default __webpack_public_path__ + "5eb6f6fb0b701be27a274bb85b58b4db.png";